<template>
  <!--<div v-if="item !== null" v-on:click.prevent.stop="item = null" class="tw-z-50 tw-fixed tw-left-0 tw-top-0 tw-h-full tw-w-full tw-bg-light tw-bg-opacity-90 tw-flex flex-center">-->
  <!--  <div class="tw-absolute tw-bottom-48 tw-top-0 tw-left-0 tw-w-full tw-flex flex-center tw-p-10">-->
  <!--    <img :src="item.url" class=" tw-max-h-full tw-max-w-full tw-w-auto" alt="">-->
  <!--  </div>-->
  <!--  <div class="tw-w-full tw-absolute tw-bottom-0 tw-h-48 tw-bg-light tw-flex tw-items-center tw-bg-opacity-50 tw-left-0">-->
  <!--      <div class="container tw-mx-auto">-->
  <!--        <div class="tw-text-4xl">{{item.title}}</div>-->
  <!--      </div>-->
  <!--  </div>-->
  <!--</div>-->
  <CoolLightBox
    :items="items"
    :index="index"
    @close="index = null"
  ></CoolLightBox>
</template>
<script>
  import CoolLightBox from "vue-cool-lightbox";
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

  export default {
    components: {
      CoolLightBox
    },
    props: {
      items: {},
      name: {},
    },
    data: v => ({
      index: null,
    }),
    created() {
      document.addEventListener('open-gallery', event => {
        console.log(event.detail)
        let name = event.detail.name
        let index = event.detail.index
        if (name === this.name) {
          this.index = index
        }
      })
    }
  }
</script>
